import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./Reducers/rootReducer";

const getAuthReducerInitState = () => {
  let token = localStorage.getItem("token");

  var authState = { isLoggedIn: false };
  if (token) authState["isLoggedIn"] = true;
  return authState;
};

const store = createStore(
  rootReducer,
  { authReducer: getAuthReducerInitState() },
  compose(
    applyMiddleware(thunk)
    //hihi
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export default store;
